module.exports = __webpack_public_path__ + "static/media/Imagen 1.1a6605c1.jpeg";